const HIGHEST_REVIEW_RATING = 5;

const schemaGenerator = data => {
  const {
    baseUrl,
    route: { path },
    productReviews,
  } = data;

  let reviewSchema = {};

  if (productReviews) {
    reviewSchema = {
      '@context': 'http://schema.org/',
      '@type': 'Review',
      review: productReviews.map(reviewData => ({
        url: `${baseUrl}${path}`,
        '@type': 'Review',
        author: {
          '@type': 'Person',
          name: reviewData.author && reviewData.author.name,
        },
        datePublished: reviewData.review.date,
        reviewBody: reviewData.review.content,
        name: reviewData.review.title,
        itemReviewed: {
          '@type': 'Product',
          name: reviewData.itemReviewed,
          image: reviewData.image,
          url: reviewData.url,
        },
        reviewRating: {
          '@type': 'Rating',
          ratingValue:
            reviewData.review &&
            reviewData.review.rating &&
            reviewData.review.rating.value,
          bestRating: HIGHEST_REVIEW_RATING,
        },
      })),
    };
    return reviewSchema;
  }
  return reviewSchema;
};

export default schemaGenerator;
